import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import About from "./Component/About";
import Account from "./Component/Account";
import CartPage from "./Component/CartPage";
import { CartProvider } from "./Component/CartContext";
import CheckOut from "./Component/CheckOut";
import Contact from "./Component/Contact";
import Cookies from "./Component/Cookies";
import Delivery from "./Component/Delivery";
import ErrorBoundary from "./Component/ErrorBoundary";
import Faq from "./Component/Faq";
import Footer from "./Component/Footer";
import Gifts from "./Component/Gifts";
import Header from "./Component/Header";
import Journal from "./Component/Journal";
import Main from "./Component/Main";
import NotFound from "./Component/NotFound";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import Recipes from "./Component/Recipes";
import Returns from "./Component/Returns";
import RouteMeta from "./Component/RouteMeta";
import ScrollToTop from "./Component/ScrollToTop";
import Shop from "./Component/Shop";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Wishlist from "./Component/Wishlist";
import Wholesale from "./Component/Wholesale";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <RouteMeta />
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Header />
        <ErrorBoundary>
          <div id="main-content" tabIndex="-1">
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/gifts" element={<Gifts />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/cart" element={<Navigate replace to="/cartpage" />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
              <Route path="/payment" element={<PaySuccess />} />
              <Route path="/account" element={<Account />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </ErrorBoundary>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
